export enum SettingsAiDataEventObjectsEnum {
  TOPICS_COPILOT_VIDEO = 'topics_copilot_video',
  SMART_QA_VIDEO = 'smart_qa_video',
  SMART_CSAT_VIDEO = 'smart_csat_video',
  ENABLE_AI_COPILOT_EDUCATION_TIP = 'enable_ai_copilot_education_tip',
  SMART_QA_INFOBOX_CREATE_RULE_LINK = 'smart_qa_infobox_create_rule_link',
  SMART_QA_ACTIVATION_BANNER_CREATE_RULE_LINK = 'smart_qa_activation_banner_create_rule_link',
  SMART_QA_ACTIVATION_BANNER_ANALYTICS_LINK = 'smart_qa_activation_banner_analytics_link',
  CONFIGURE_AI_COPILOT_STEPS_SELECT_INBOXES_TIP = 'configure_ai_copilot_steps_select_inboxes_tip',
  CONFIGURE_AI_COPILOT_STEPS_ADD_SOURCES_TIP = 'configure_ai_copilot_steps_add_sources_tip',
  CONFIGURE_AI_COPILOT_KNOWLEDGE_BASE_TIP = 'configure_ai_copilot_knowledge_base_tip',
  FEATURE_HELP_REQUEST_LINK = 'feature_help_request_link',
  AI_REPLY_LIST = 'ai_reply_list',
  AI_REPLY = 'ai_reply',
  AI_REPLY_OPEN_CONVERSATION = 'ai_reply_open_conversation',

  // Manage Sources Dialog
  MANAGE_SOURCES_DIALOG = 'manage_sources_dialog',

  // Knowledge Source Sync
  KNOWLEDGE_SOURCE_SYNC_TRIGGERED = 'knowledge_source_sync_triggered',
  KNOWLEDGE_SOURCE_SYNC_COMPLETED = 'knowledge_source_sync_completed',
  KNOWLEDGE_SOURCE_SYNC_FAILED = 'knowledge_source_sync_failed',

  // Knowledge Sources Page
  KNOWLEDGE_SOURCES_PAGE = 'knowledge_sources_page',
  KNOWLEDGE_SOURCES_MANAGE_BUTTON = 'knowledge_sources_manage_button',
  KNOWLEDGE_SOURCES_SETTINGS = 'knowledge_sources_settings',
  KNOWLEDGE_SOURCES_SETTINGS_ERROR = 'knowledge_sources_settings_error',

  // Add Sources Button
  KNOWLEDGE_SOURCES_ADD_BUTTON = 'knowledge_sources_add_button',
  KNOWLEDGE_SOURCES_ADD_OPTION = 'knowledge_sources_add_option',
  KNOWLEDGE_SOURCES_SOURCE_ADDED = 'knowledge_sources_source_added',

  // Knowledge Sources Activation Banner
  KNOWLEDGE_SOURCES_ACTIVATION_BANNER = 'knowledge_sources_activation_banner',
}
